import React, { useState, memo } from 'react';
import { styled } from '@compiled/react';
import Popup from '@atlaskit/popup';
import { N0, N400 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import ReleaseIcon from '../../../common/ui/release-icon';
import type { Release } from '../../../types';
import ReleasePopup from './release-popup';

export type Props = {
	release: Release;
};

export const CalendarRelease = ({ release }: Props) => {
	const { name } = release;
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	return (
		<Popup
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			placement="top-start"
			content={() => <ReleasePopup release={release} />}
			trigger={(triggerProps) => (
				<div {...triggerProps}>
					<EventWrapper
						onClick={() => {
							setIsOpen(!isOpen);
							fireUIAnalytics(createAnalyticsEvent({}), 'calendarReleaseItem clicked', {
								popupOpening: !isOpen,
							});
						}}
						data-testid="business-calendar.ui.calendar-view.calendar-release.event-wrapper"
					>
						<ReleaseIcon size="small" />
						<ReleaseWrapper>{name}</ReleaseWrapper>
					</EventWrapper>
				</div>
			)}
		/>
	);
};

export default memo(CalendarRelease);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EventWrapper = styled.button({
	border: 0,
	width: '100%',
	textAlign: 'left',
	padding: `${token('space.075', '6px')} ${token('space.100', '8px')} ${token('space.075', '6px')}`,
	display: 'flex',
	flexWrap: 'wrap',
	cursor: 'pointer',
	minHeight: '20px',
	lineHeight: '20px',
	borderRadius: '4px',
	alignItems: 'center',
	backgroundColor: token('color.background.neutral.bold', N400),
	color: token('color.text.inverse', N0),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ReleaseWrapper = styled.div({
	flex: 1,
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontWeight: 500,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	lineHeight: `${gridSize * 2}px`,
});
